import AppVersionUtil from 'Utils/AppVersionUtil';
// https, not `market://`: in-app, the native shell only hands the OS URLs matching the
// allowlist from `app/externalurls`, so a custom scheme falls through and the WebView
// loads it itself. These work from a plain browser too, which the OAuth fallback page needs.
// The iOS URL carries `?l=ja` so the allowlist prefix ends mid-QUERY. Appended path
// segments then land in the query instead of walking the path: without it,
// `…/id1484451230/../../../us/app/evil/id…` passes the allowlist's prefix test and
// normalises to a different App Store listing. The Play URL already ends in a query.
const STORE_URL = {
    ios: 'https://apps.apple.com/jp/app/id1484451230?l=ja',
    android: 'https://play.google.com/store/apps/details?id=com.indeed.resume'
};
/** The store listing for the platform we're running on. */
export const storeUrl = () => AppVersionUtil.isAppleDevice() ? STORE_URL.ios : STORE_URL.android;
/** The web app. Absolute: callers include a page whose route tolerates a trailing slash. */
export const WEB_APP_PATH = '/rirekisho/form';
// `openExternalBrowser=1` does double duty: it's in the external-URL allowlist, so the
// native shell hands this URL to the OS instead of loading it in the WebView, and
// `smartbanner_hidden` already keys off it — so someone sent here because they CAN'T
// install the app isn't then greeted by a download banner.
export const WEB_APP_EXTERNAL_PATH = `${WEB_APP_PATH}?openExternalBrowser=1`;
export default STORE_URL;
